import { DoorSize } from '../../common/door-size';
import { StormDoorHandleType } from '../../common/storm-door-handle-type';
import { StormDoorColor } from '../../common/storm-door-color';

export interface IPublishLowesStormDoorRequest {
    vendor: string;
    description: string;
    imageUrls: string[];
    sellingPoints: string[];
    isRejected: boolean;
    familyId: string;
    doorSize: DoorSize;
    validHandlesets: StormDoorHandleType;
    includesHandle: boolean;
    cutdownPossible: boolean;
    variantColorFamilies: StormDoorColor[];
    productReviewSummary: string;
}


export class PublishLowesStormDoorRequest implements IPublishLowesStormDoorRequest {
    public vendor: string = '';
    public description: string = '';
    public imageUrls: string[] = [];
    public sellingPoints: string[] = [];
    public isRejected: boolean = false;
    public familyId: string = '';
    public doorSize: DoorSize = DoorSize.Indeterminate;
    public validHandlesets: StormDoorHandleType = StormDoorHandleType.Indeterminate;
    public includesHandle: boolean = false;
    public cutdownPossible: boolean = false;
    public variantColorFamilies: StormDoorColor[] = [];
    public productReviewSummary: string = '';
}


